import { CustomTextField } from 'components/forms';
import { TextFieldProps } from 'formik-material-ui';
// eslint-disable-next-line
import React from 'react';
import dictionary from 'utils/dictionary';
import { RGX_ONLY_NUMBERS } from 'utils/helpers';

type Props = TextFieldProps;

const AreaCodeField: React.FC<Props> = (props) => {
  return (
    <CustomTextField
      label={dictionary.clientForm_label_areaCode}
      regex={RGX_ONLY_NUMBERS}
      {...props}
    />
  );
};

export default AreaCodeField;
